import { io } from "socket.io-client";

let socket = null;

/**
 * 获取 socket 实例（单例）
 * @returns {import('socket.io-client').Socket}
 */
export function getSocket() {
  if (socket && socket.connected) return socket;

  const url = process.env.VUE_APP_SOCKET_URL;
  console.log("连接 Socket.io 服务器:", url);
  socket = io(url, {
    transports: ["websocket", "polling"],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 10000
  });

  socket.on("connect", () => {
    console.log("[Socket] 连接成功:", socket.id);
  });

  socket.on("disconnect", (reason) => {
    console.log("[Socket] 连接断开:", reason);
  });

  socket.on("connect_error", (err) => {
    console.warn("[Socket] 连接错误:", err.message);
  });

  return socket;
}

/**
 * 断开连接并销毁实例
 */
export function destroySocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
